import React, {PureComponent} from "react"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {H4} from "@irati/ui/src//Typography/Heading"
import {Para} from "@irati/ui/src/Labels"
import intercom from "@irati/utils/intercom"
import {TenantOnboardingStep} from "@irati/types"
import tenantSetupTracking, {TenantSetupInterfaces} from "@irati-tracking/tenant-setup"
import {TENANT_SETUP_TOUR_PREFIX} from "../../tour"
import {SideBarContainer, SideBarFooter, SideBarMainContent} from "./styled"
import InviteAdminButton from "../InviteAdmin/InviteAdminButton"
import Navigation from "./Navigation"
import {getCurrentTenantSetupStepConfig} from "../../helpers"

interface Props extends InjectIntl {
  onboardingSteps: TenantOnboardingStep[],
  customiseSteps: TenantOnboardingStep[],
  communicateSteps: TenantOnboardingStep[],
  inviteSteps: TenantOnboardingStep[]
}

class SideBar extends PureComponent<Props> {
  toggleIntercom = () => {
    const {onboardingSteps, formatMessage} = this.props
    const currentStepConfig = getCurrentTenantSetupStepConfig()
    if (!currentStepConfig) {
      return intercom.addCustomMessage(this.props.formatMessage({id: "setup_tenant.sidebar.help.prePopInviteAdmin"}))
    }
    const currentStep = onboardingSteps!.find((step) => step.stepId === currentStepConfig!.stepId)
    if (currentStep) {
      const params: TenantSetupInterfaces.StepAndOptionsParams = {
        step_name: formatMessage({id: currentStepConfig?.title}),
        step_id: currentStep.stepId,
        step_number: currentStepConfig!.order,
        option_id: currentStep.selection
      }
      tenantSetupTracking.openIntercom(params)
    }
    intercom.addCustomMessage(this.props.formatMessage({id: "setup_tenant.sidebar.help.prePopMessage"}), window.location.href)
  }

  render() {
    const {customiseSteps, communicateSteps, inviteSteps} = this.props
    return (
      <SideBarContainer>
        <SideBarMainContent data-tour={`${TENANT_SETUP_TOUR_PREFIX}step01`}>
          <InviteAdminButton />
          <Navigation customiseSteps={customiseSteps} communicateSteps={communicateSteps} inviteSteps={inviteSteps} />
        </SideBarMainContent>

        <SideBarFooter data-tour={`${TENANT_SETUP_TOUR_PREFIX}step04`} onClick={this.toggleIntercom}>
          <H4 tiny>
            <FormattedMessage id="setup_tenant.sidebar.help.title" />
          </H4>
          <Para>
            <FormattedMessage id="setup_tenant.sidebar.help.description" />
          </Para>
        </SideBarFooter>
      </SideBarContainer>
    )
  }
}

export default injectIntl(SideBar)
export {SIDEBAR_WIDTH} from "./styled"
